import { atom } from "jotai";

import type { OutputFeedbackOutputType, OutputFeedbackRating } from "./types";

export const outputFeedbackKey = ({
  outputType,
  outputId,
}: {
  outputType: OutputFeedbackOutputType;
  outputId: string;
}) => `${outputType}:${outputId}`;

/**
 * The caller's rating per output, keyed by `outputType:outputId`. Hydrated from
 * `/api/v4/feedback` when a session loads and updated optimistically on submit.
 */
export const outputFeedbackRatingsAtom = atom<Record<string, OutputFeedbackRating>>({});
